export const PROPERTY_ID = "propertyId";
export const DISPLAY_ID = "displayId";
export const PROPERTY_NAME = "name";
export const UNIT_NUMBER = "unitNumber";
export const PIN = "pin";
export const INSURANCE_TYPE = "insuranceTypeId";
export const PROPERTY_MODEL = "modelId";
export const PROPERTY_SIZE = "propertySizeSft";
export const NO_OF_GARAGES = "garageCount";
export const ADDRESS = "address";
export const ADDRESS_1 = "addressLine1";
export const ADDRESS_2 = "addressLine2";
export const STATE = "state";
export const CITY = "city";
export const ZIPCODE = "zipCode";
export const EMERGENCY_CONTACTS = "emergencyContacts";
export const POC_NAME = "pocName";
export const POC_MOB_NO = "pocMobileNo";
export const POC_EMAIL = "pocEmailId";
export const COMMUNITY_ID = "communityId";
export const COMMUNITY_NAME = "communityName";
export const COUNTRY = "country";
export const CATEGORY = "categoryId";
export const PROPERTY_ZONE = "zoneId";
export const PROPERTY_BLOCK = "blockId";
export const IS_RENTED = "rented";